function endDateMs(item) {
  if (!item.period || item.period.disabled) return 0
  if (item.period.currently) return Infinity
  if (!item.period.endDate) return 0
  return new Date(item.period.endDate).getTime()
}

export function sortByOrderOrDate(items) {
  const withOrder = items.filter(i => i.order != null).sort((a, b) => a.order - b.order)
  const withoutOrder = items.filter(i => i.order == null).sort((a, b) => {
    const aMs = endDateMs(a)
    const bMs = endDateMs(b)
    if (aMs === bMs) return 0
    if (aMs === Infinity) return -1
    if (bMs === Infinity) return 1
    return bMs - aMs
  })
  return [...withOrder, ...withoutOrder]
}
